import React, { useMemo } from 'react';
import { Modal, ModalHeader, SelectPopover } from '@planne-software/uni';
import { Box, Stack, Typography } from '@planne-software/uni/mui/material';
import EmbedPlanneSeatmap from './EmbedPlanneSeatmap';
import { useSeatmapSelector } from './useSeatmapSelector';
import { SequentialSlotShell } from '../SequentialSlotShell';

const SeatmapSelector = () => {
  const {
    isVisible,
    sequentialSlot,
    disabled,
    modalOpen,
    openModal,
    closeModal,
    i18n,
    scheduling,
    selectedHour,
    selectedTariffs,
    selectSeatFromMap,
    embedActions,
    selectedResourceLabel,
  } = useSeatmapSelector();

  const selectedElement = useMemo(() => {
    if (!selectedResourceLabel) {
      return undefined;
    }

    return (
      <Typography variant='text-sm-semibold' noWrap sx={{ textAlign: 'left', width: '100%' }}>
        {selectedResourceLabel}
      </Typography>
    );
  }, [selectedResourceLabel]);

  if (!isVisible || !scheduling) {
    return null;
  }

  return (
    <SequentialSlotShell slot={sequentialSlot}>
      <SelectPopover
        name='product-booking-seatmap'
        fullWidth
        size='sm'
        disabled={disabled}
        disablePopover
        placeholder={i18n('seatMap_selectSeat')}
        selectedElement={selectedElement}
        onClick={openModal}
      >
        {null}
      </SelectPopover>

      <Modal open={modalOpen} onClose={closeModal} sx={(theme) => ({ zIndex: theme.zIndex.modal + 9999 })}>
        <Stack sx={{ height: '100vh', display: 'flex', overflow: 'hidden', flexDirection: 'column' }}>
          <ModalHeader title={i18n('seatMap_selectSeat')} onClose={closeModal} divider />
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <EmbedPlanneSeatmap
              scheduling={scheduling}
              timeMinutes={selectedHour}
              selectedTariffs={selectedTariffs}
              onSelectionChange={selectSeatFromMap}
              embedActions={embedActions}
            />
          </Box>
        </Stack>
      </Modal>
    </SequentialSlotShell>
  );
};

export default SeatmapSelector;
export type { UseSeatmapSelectorResult } from './types';
